// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Button from '../core/button';

// Containers
import withPermissions from '../../containers/with-permissions';

// Styles
import './mapping-ams-to-network-displaypath-button.scss';

function MappingAmsToNetworkDisplayPathButton({className, echostarId, mapButtonOnClick}) {
    const getButtonProps = () => ({
        className: classnames('mapping-ams-to-network-displaypath-button', className),
        children: 'Map',
        disabled: false,
        onClick: (event) => handleClick(event, echostarId, mapButtonOnClick),
    });

    const handleClick = (event, echostarId, mapButtonOnClick) => {
        event && event.preventDefault && event.preventDefault();
        mapButtonOnClick(echostarId);
    };

    const renderButton = () => (echostarId !== undefined ? <Button {...getButtonProps()} /> : null);

    return <div>{renderButton()}</div>;
}

MappingAmsToNetworkDisplayPathButton.propTypes = {
    className: PropTypes.string,
    echostarId: PropTypes.number,
    mapButtonOnClick: PropTypes.func,
};

export default withPermissions(MappingAmsToNetworkDisplayPathButton);
